
export const getOccurrenceSchedule = ({ occurrenceType, occurrenceValues }) => {

  let schedule = {};

  if (occurrenceType === 'weekly') {
    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    schedule = {
      year: null,
      dates: null,
      day: null,
      wday: occurrenceValues.map((v) => weekdays.indexOf(v))
    };
  }

  if (occurrenceType === 'monthly') {
    schedule = {
      year: null,
      dates: null,
      day: occurrenceValues,
      wday: null
    };
  }
  if (occurrenceType === 'annually') {

    let yearArray = occurrenceValues;
    var newDays = [];
    var newMonths = [];

    yearArray?.map(item => {
      const monthDay = item.split("/");
      newDays.push(monthDay[1]);
      newMonths.push(monthDay[0]);
    })

    schedule = {
      month: newMonths,
      day: newDays
    };
  }

  return schedule;
}

export const getOccurrence = (schedule) => {
  const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  let occurrenceType = 'monthly';
  let occurrenceValues = [];

  if (!schedule) {
    return { occurrenceType: '', occurrenceValues: [] }
  }

  if (!!schedule.month) {
    occurrenceType = 'annually';
  }
  if (!!schedule.wday) {
    occurrenceType = 'weekly'
  }

  if (occurrenceType === 'weekly') {
    occurrenceValues = schedule.wday.map(d => weekdays[d])
  }
  if (occurrenceType === 'monthly') {
    occurrenceValues = schedule.day.map(d => d.toString())
  }
  if (occurrenceType === 'annually') {
    occurrenceValues = schedule.month.map((m, i) => `${m}/${schedule.day[i]}`)
  }

  return { occurrenceType, occurrenceValues }
}

export const recurringDays = (schedule) => {
  let weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let wDays = schedule?.wday;
  let day = schedule?.day;
  let month = schedule?.month;

  let newYearArray = month?.map((item, i) =>
    `${item}/${day[i]}`
  )

  let resultent = wDays?.map((item, i) => {
    return weekdays[item];
  });

  return wDays ? `Weekly on ${resultent} ` ?? '' : month ? `Yearly on ${newYearArray} ` ?? '' : `Monthly on ${day} ` ?? '';
}
